import BranchesOverview from '../../features/branches/BranchesOverview';

const Branches = () => {
  return <BranchesOverview />;
};

export default Branches;
